import FontBody1 from "../../../fonts/font-body1/font-body1";
import { FONT_COLOR } from "../../../fonts/font-props";
import { BUTTON_VARIANTS } from "../../../inputs/button-variants";
import { Button } from "../../../inputs/button/button";
import { DefaultModalLayout } from "../../layouts/default-modal-layout";

import './notification-modal.scss';

interface INotificationModalProps {
    title?: string,
    text: React.ReactNode,
    okButton?: {
        title: string,
        onClick: () => void
    }
}

export const NotificationModal: React.FC<INotificationModalProps> = ({
    title,
    text,
    okButton = {
        title: 'OK',
        onClick: () => {},
    }
}) => {
    return (
        <DefaultModalLayout onCloseClicked={() => okButton?.onClick()} isCloseDisabled={false}>
            <div className="notification-modal">
                {title && <div className="notification-modal-title">
                    <FontBody1 color={FONT_COLOR.NEUTRAL3}>{ title }</FontBody1>
                </div>}
                <div className="notification-modal-text">
                    <FontBody1 color={FONT_COLOR.PRIMARY3}>{ text }</FontBody1>
                </div>
                <div className="notification-modal-buttons">
                    <Button text={okButton?.title} onClick={okButton?.onClick} variant={BUTTON_VARIANTS.Primary} />
                </div>
            </div>
        </DefaultModalLayout>
    );
}
